import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private tooltips: Set<() => void> = new Set();
  private activeTooltip: (() => void) | null = null;

  constructor(private router: Router) {
    // Clean up all tooltips on route navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.cleanupAllTooltips();
      });
  }

  registerTooltip(cleanupFn: () => void) {
    this.tooltips.add(cleanupFn);
  }

  unregisterTooltip(cleanupFn: () => void) {
    this.tooltips.delete(cleanupFn);
    if (this.activeTooltip === cleanupFn) {
      this.activeTooltip = null;
    }
  }

  setActiveTooltip(cleanupFn: () => void) {
    // Hide the previous active tooltip if different
    if (this.activeTooltip && this.activeTooltip !== cleanupFn) {
      this.activeTooltip();
    }
    this.activeTooltip = cleanupFn;
  }

  clearActiveTooltip(cleanupFn: () => void) {
    if (this.activeTooltip === cleanupFn) {
      this.activeTooltip = null;
    }
  }

  cleanupAllTooltips() {
    this.tooltips.forEach(cleanup => cleanup());
    this.activeTooltip = null;
  }
}
